export default __webpack_public_path__ + "static/media/Nutextracts.2f56e527.jpg";